import React from "react"
import autobind from "class-autobind"
import { Paper, IconButton, FontIcon, Avatar, Dialog, FlatButton, CircularProgress, TableBody, TableHeader, TableRow, TableHeaderColumn, TableRowColumn } from "material-ui"
import Table from "../../components/common/Table"
import { browserHistory } from "react-router"
import * as api from "../../api"
import { enableIntercom } from "../../../intercom"
import AppStateStore from "../../stores/AppStateStore"
import AuthenticationStore from "../../stores/AuthenticationStore"
import AccountManagerDetails from "../../components/account_manager/AccountManagerDetails"
import strings from "../../localization/strings"
import { IAccountManagerDocument } from "../../models"
import { logout } from "../../actions/LoginActions"

declare global {
    interface Window {
        Intercom: any
    }
}

interface IState {
    accountManagers: IAccountManagerDocument[]
    selectedAccountManagers: IAccountManagerDocument[]
    selectedAccountManagerIdToNavigate: string
    openAccountManagerNavigateDialog: boolean
    showAccountManagerDetails: boolean
    loading: boolean
}

export default class AccountManager extends React.Component<null, IState> {
    constructor(props) {
        super(props)
        this.state = {
            accountManagers: [],
            selectedAccountManagers: [],
            selectedAccountManagerIdToNavigate: AuthenticationStore.getLoggedInAccountManagerUser().ViewAllAccountManagers === false && localStorage.getItem("selectedAccountManagerIdToNavigate") ? localStorage.getItem("selectedAccountManagerIdToNavigate") : null,
            openAccountManagerNavigateDialog: false,
            showAccountManagerDetails: false,
            loading: false,
        }
        autobind(this)
    }

    componentDidMount(): void {
        document.title = strings.Findd_Account_Manager
        this.checkAndGetDataForMultipleAMs()
        setTimeout(() => {
            browserHistory.listen(this.routeChanged)
        }, 0)
    }

    componentWillUnmount(): void {
        document.title = strings.Findd_Grandd_Central
    }

    routeChanged() {
        enableIntercom() &&
            window.Intercom("update")
    }

    checkAndGetDataForMultipleAMs() {
        const loggedInAMUser = AuthenticationStore.getLoggedInAccountManagerUser()
        if (loggedInAMUser.ViewAllAccountManagers === false) {
            if (loggedInAMUser.AccountManagerIds && loggedInAMUser.AccountManagerIds.length > 1) {
                if (this.state.selectedAccountManagerIdToNavigate === null) this.setState({ openAccountManagerNavigateDialog: true, loading: true }, () => this.getData())
                else this.setState({ showAccountManagerDetails: true })
            }
            else if (loggedInAMUser.AccountManagerIds && loggedInAMUser.AccountManagerIds.length === 1) {
                this.setState({ showAccountManagerDetails: true, selectedAccountManagerIdToNavigate: loggedInAMUser.AccountManagerIds[0] })
            }
        } else {
            this.setState({ showAccountManagerDetails: true })
        }
    }

    getData() {
        api.getAccountManagers().then(res => {
            this.setState({ accountManagers: res.data, loading: false })
        })
            .catch(err => {
                err.response.status === 400 &&
                    AppStateStore.setProgressSnackbarContent(err.response.data.message)
            })
    }

    render() {
        return (
            <div className="page-container">
                <div className="page-container-parent page-paper">
                    <div style={{ fontSize: 30, fontWeight: "bold", textAlign: "center" }}>{strings.AccountManager}</div>
                    <IconButton onTouchTap={() => logout()} tooltip={"Logout"} tooltipPosition={"bottom-right"} style={{ width: "auto", height: "auto", padding: 0 }}>
                        <Avatar
                            backgroundColor={AppStateStore.getFrontEndSettings().UISettings.AccentColor}
                            size={56}
                            icon={<FontIcon className="fa fa-sign-out" style={{ fontSize: 35, color: "white" }} />}
                        />
                    </IconButton>
                    <div style={{ marginTop: 30 }}>
                        {this.state.showAccountManagerDetails &&
                            <Paper>
                                <div>
                                    <AccountManagerDetails
                                        accountManagerId={this.state.selectedAccountManagerIdToNavigate}
                                    />
                                </div>
                            </Paper>
                        }
                        <Dialog
                            open={this.state.openAccountManagerNavigateDialog}
                            contentStyle={{ maxWidth: 1000, width: 900 }}
                            title={strings.To_which_Account_Manager_you_want_to_Navigate}
                            actions={[
                                <FlatButton
                                    primary
                                    label={strings.Select}
                                    style={{ display: "inline-block" }}
                                    disabled={this.state.selectedAccountManagers.length === 0}
                                    onTouchTap={() => {
                                        localStorage.setItem("selectedAccountManagerIdToNavigate", this.state.selectedAccountManagers[0].Id)
                                        this.setState({ openAccountManagerNavigateDialog: false, showAccountManagerDetails: true, selectedAccountManagerIdToNavigate: this.state.selectedAccountManagers[0].Id })
                                    }}
                                />
                            ]}
                        >
                            <div>
                                {this.state.loading ?
                                    <div className="spinner"><CircularProgress /></div> :
                                    <Table
                                        items={this.state.accountManagers}
                                        singleSelectable
                                        handleSelect={selectedAccountManagers => this.setState({ selectedAccountManagers })}
                                    >
                                        <TableHeader>
                                            <TableRow>
                                                <TableHeaderColumn>{strings.Name}</TableHeaderColumn>
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody showRowHover deselectOnClickaway={false}>
                                            {this.state.accountManagers.map((row) =>
                                                <TableRow key={row.Id} selected={this.state.selectedAccountManagers.find(item => item.Id === row.Id) ? true : false}>
                                                    <TableRowColumn>{row.Name}</TableRowColumn>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                }

                            </div>
                        </Dialog>
                    </div>
                </div>
            </div>
        )
    }
}